export default "__VITE_ASSET__9d4601fc__"